import {
  AUTHORIZED_MODULE,
  NOTIFICATION,
  SYSTEM_MODULE,
  USER_MODULE,
  REPORT_MODULE,
  SETTINGS_MODULE,
  VIOLATIONS_MODULE,
  ZONES_MODULE,
  EVACUATIONS_MODULE,
  GEOGRAPHY_MODULE,
  POLICIES_MODULE,
  RULES_MODULE,
  AGENCY_MODULE,
  STOPS_MODULE,
  PROVIDER_MODULE,
  TELEMETRY_MODULE,
} from '../configs/moduleNames';

import System from './System';
import Authorized from './Authorized';
import Notifications from './Notifications';
import Violations from './Violations';
import WebSocket from './WebSocket';
import User from './User';
import Report from './Report';
import Settings from './Settings';
import Zones from './Zones';
import Evacuations from './Evacuations';
import Geography from './Geography';
import Rules from './Rules';
import Policies from './Policies';
import Agency from './Agency';
import Stops from './Stops';
import Provider from './Provider';
import Telemetry from './Telemetry';

const modules = {
  [SYSTEM_MODULE]: System,
  [AUTHORIZED_MODULE]: Authorized,
  [NOTIFICATION]: Notifications,
  [ZONES_MODULE]: Zones,
  [AGENCY_MODULE]: Agency,
  [TELEMETRY_MODULE]: Telemetry,
  // [STOPS_MODULE]: Stops,
  [GEOGRAPHY_MODULE]: Geography,
  [RULES_MODULE]: Rules,
  [POLICIES_MODULE]: Policies,
  [VIOLATIONS_MODULE]: Violations,
  [EVACUATIONS_MODULE]: Evacuations,
  [REPORT_MODULE]: Report,
  [USER_MODULE]: User,
  [PROVIDER_MODULE]: Provider,
  // [SETTINGS_MODULE]: Settings,
};

export default modules;
